var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 125 100",
    viewBox: "0 0 125 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EE7203;}\r\n\t.st1{fill:#000000;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m75.709 64.547h-37.383c-0.86938 0-1.6146 0.67466-1.6146 1.2529 0 0.67466 0.86938 1.2529 1.6146 1.2529h37.383c0.86938 0 1.6146-0.67466 1.6146-1.2529 0.1242-0.57828-0.74518-1.2529-1.6146-1.2529z",
    fill: "#EE7203",
    stroke: "#EE7203",
    strokeWidth: 1.0941
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m75.709 52.914h-37.383c-0.86938 0-1.6146 0.67466-1.6146 1.2529 0 0.67466 0.86938 1.2529 1.6146 1.2529h37.383c0.86938 0 1.6146-0.67466 1.6146-1.2529 0.1242-0.57828-0.74518-1.2529-1.6146-1.2529z",
    fill: "#EE7203",
    stroke: "#EE7203",
    strokeWidth: 1.0941
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m86 13.5c0-0.7-0.7-1.3-1.3-1.3h-56c-0.7 0-1.3 0.7-1.3 1.3v72.9c0 0.7 0.7 1.3 1.3 1.3h56c0.7 0 1.3-0.7 1.3-1.3v-6c0-0.7-0.7-1.3-1.3-1.3-0.7 0-1.3 0.7-1.3 1.3v4.7h-53.6v-70.2h53.5l0.11124 69.561c0.0011 0.7 0.7 1.3 1.3 1.3 0.7 0 1.3009-0.7 1.3-1.3l-0.11124-70.961z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m75.709 29.647h-37.383c-0.86938 0-1.6146 0.67466-1.6146 1.2529 0 0.67466 0.86938 1.2529 1.6146 1.2529h37.383c0.86938 0 1.6146-0.67466 1.6146-1.2529 0.1242-0.57828-0.74518-1.2529-1.6146-1.2529z",
    fill: "#EE7203",
    stroke: "#EE7203",
    strokeWidth: 1.0941
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m75.709 41.28h-37.383c-0.86938 0-1.6146 0.67466-1.6146 1.2529 0 0.67466 0.86938 1.2529 1.6146 1.2529h37.383c0.86938 0 1.6146-0.67466 1.6146-1.2529 0.1242-0.57828-0.74518-1.2529-1.6146-1.2529z",
    fill: "#EE7203",
    stroke: "#EE7203",
    strokeWidth: 1.0941
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.dd77390363508a8f5d5957a9efadde1d.svg";
export { ForwardRef as ReactComponent };